import { render, staticRenderFns } from "./fccFiltraCorrecaoCadastral.vue?vue&type=template&id=58253876"
import script from "./fccFiltraCorrecaoCadastral.vue?vue&type=script&lang=js"
export * from "./fccFiltraCorrecaoCadastral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports